import request, { ResponsePageableData } from '@/libs/request'

/** 同步绿云酒店信息 */
export const pullHotelInfo = (data?) => request<ResponsePageableData>({ url: '/adminapi/GreenCloud/pullHotelInfo', data })
